import { createStyles } from "@app/components/tss/hooks/use-tss-styles";

export const useStyles = createStyles(({ theme }) => {
  const { gradients } = theme.busbud;

  return {
    layoutRoot: {
      background: gradients.component.page.background,
      height: "100vh"
    },
    grid: {
      height: "100vh",
      alignItems: "center"
    }
  };
});
